const ACTIONS = {
    SET_CIDADES: 'SET_CIDADES',
    SET_UF: 'SET_UF',
    SET_CIDADEID: 'SET_CIDADEID',
    SET_CIDADE_SELECIONADA: 'SET_CIDADE_SELECIONADA',
    CLEAR_CIDADES: 'CLEAR_CIDADES',
};
const INITIAL_STATE = {
    cidades: [],
    uf: "",
    cidadeId: "",
    cidadeSelecionada: {}
};
export function CidadesReducer(state = INITIAL_STATE, action) {
    switch (action.type) {
        case ACTIONS.SET_CIDADES:
            return {
                ...state,
                cidades: action.cidades
            };
        case ACTIONS.SET_UF:
            return {
                ...state,
                uf: action.uf
            };
        case ACTIONS.SET_CIDADEID:
            return {
                ...state,
                cidadeId: action.cidadeId
            };
        case ACTIONS.SET_CIDADE_SELECIONADA:
            return {
                ...state,
                cidadeSelecionada: action.cidadeSelecionada
            };
        case ACTIONS.CLEAR_CIDADES:
            return {
                ...state,
                cidades: []
            };
        default:
            return state;
    }
}
